import { render, staticRenderFns } from "./StepDateOfBirth.vue?vue&type=template&id=1852445c&scoped=true&"
import script from "./StepDateOfBirth.vue?vue&type=script&lang=js&"
export * from "./StepDateOfBirth.vue?vue&type=script&lang=js&"
import style0 from "./StepDateOfBirth.vue?vue&type=style&index=0&id=1852445c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852445c",
  null
  
)

export default component.exports